
import { defineComponent } from 'vue'
import AuditLogFieldTypesDisplayingValuesArrayValue
    from '@/components/employees-audit-log/field-types/displaying-values/array-value.vue'
import AuditLogFieldTypesDisplayingValuesBoolValue
    from '@/components/employees-audit-log/field-types/displaying-values/bool-value.vue'
import AuditLogFieldTypesDisplayingValuesDefaultValue
    from '@/components/employees-audit-log/field-types/displaying-values/default-value.vue'

export default defineComponent({
    name: 'audit-log-field-types-displaying-values-index',
    components: {
        AuditLogFieldTypesDisplayingValuesDefaultValue,
        AuditLogFieldTypesDisplayingValuesBoolValue,
        AuditLogFieldTypesDisplayingValuesArrayValue
    },
    props: {
        value: {
            required: true
        }
    },
    setup (props) {
        const getComponent = () => {
            switch (true) {
            case Array.isArray(props.value):
                return 'AuditLogFieldTypesDisplayingValuesArrayValue'
            case typeof props.value === 'boolean':
                return 'AuditLogFieldTypesDisplayingValuesBoolValue'
            default:
                return 'AuditLogFieldTypesDisplayingValuesDefaultValue'
            }
        }

        const component = getComponent()
        return {
            component
        }
    }
})
